import { cssVar } from '../theme/variables.js';
import { styled } from 'styled-components';
import { Flex } from './Flex.js';

const BadgeCount = styled(Flex).attrs((p) => {
  return {
    alignItems: "center",
    justifyContent: "center",
    ...p
  };
}).withConfig({
  displayName: "BadgeCount",
  componentId: "sc-3193c276-0"
})([
  `font-weight:600;background:rgba(`,
  `,0.05);color:rgba(`,
  `,0.5);padding:0 3px;border-radius:6px;height:19px;font-size:0.75rem;flex-shrink:0;`
], cssVar["color-bg-primary-reverse-rgb"], cssVar["color-bg-primary-reverse-rgb"]);

export { BadgeCount };
//# sourceMappingURL=BadgeCount.js.map
